import { render, staticRenderFns } from "./ComfirmHome.vue?vue&type=template&id=1d18500a&scoped=true&"
import script from "./ComfirmHome.vue?vue&type=script&lang=js&"
export * from "./ComfirmHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d18500a",
  null
  
)

export default component.exports